import PropTypes from "prop-types";
import React, { Component } from "react";
import { Dialog } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Trans } from "@lingui/macro";
import { withStyles } from "@material-ui/core";
import { showFaq } from "../actions";
import { connect } from "react-redux";
import FormFaq from "./FormFaq";
import { contact } from "../utils/fetcher";
import { ArrowDropDown } from "@material-ui/icons";

const styles = () => ({
  dialog: {
    borderRadius: "15px"
  }
});

class Faq extends Component {
  state = {
    question_response: [],
    open: true
  };

  componentDidMount() {
    const question_response = this.props.faq;
    this.setState({ question_response });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.showFaq(false);
    this.setState({ open: false });
  };

  getRenderFaq = () => {
    let lengthFaq = this.state.question_response.length - 1;

    return (
      this.state.question_response &&
      this.state.question_response.map((item, key) => {
        return (
          <Accordion key={key}>
            <AccordionSummary
              aria-controls={`panel${key}bh-content`}
              id={`panel${key}bh-header`}
              expandIcon={<ArrowDropDown className="primary" />}
              className="question"
            >
              <strong dangerouslySetInnerHTML={{ __html: item.question_faq }} />
            </AccordionSummary>
            <AccordionDetails className="response">
              <div dangerouslySetInnerHTML={{ __html: item.reponse_faq }} />
              {key === lengthFaq && (
                <FormFaq
                  message={this.props.message}
                  onSubmit={this.props.contact}
                  telDefault={this.props.telDefault}
                />
              )}
            </AccordionDetails>
          </Accordion>
        );
      })
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <Dialog
        aria-labelledby="faq-dialog-title"
        open={this.state.open}
        onClose={this.handleClose}
        classes={{
          paper: classes.dialog
        }}
      >
        <DialogTitle id="faq-dialog-title">
          <span className="icon-question">?</span>
        </DialogTitle>
        <div className="content-faq">
          {this.getRenderFaq()}
          <div className="content-btn">
            <button className="custom-btn" onClick={this.handleClose}>
              <Trans id="W_STEP_BOUTON_FERMER" />
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

Faq.propTypes = {
  classes: PropTypes.shape({
    dialog: PropTypes.any
  }),
  contact: PropTypes.any,
  faq: PropTypes.any,
  message: PropTypes.any,
  showFaq: PropTypes.func,
  telDefault: PropTypes.any
};

const mapStateToProps = state => {
  return {
    faq: state.faq,
    message: state.message,
    telDefault: state.configuration.teldefaut || "fr"
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showFaq: isShow => dispatch(showFaq(isShow)),
    contact: values => dispatch(contact(values))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Faq)
);
